<div class="ag-grid-skeleton-overlay">
  <div class="loading-table">
    <!-- Skeleton rows -->
    <div class="loading-row" *ngFor="let row of rows" [ngStyle]="getRowStyle()">
      <div
        *ngFor="let column of columns"
        [class]="getCellClass(column)"
        [ngStyle]="getCellStyle(column)">
        <p-skeleton
          [width]="column.skeletonWidth || '80%'"
          height="20px">
        </p-skeleton>
      </div>
    </div>
  </div>
</div>
